import { Layout } from "antd";
import React from "react";
import logo from "assets/cemlogo.png";
import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import { IGeneralState, ISidemenu } from "types";
import { useSelector } from "react-redux";

const { Sider } = Layout;

export const Sidemenu: React.FC<ISidemenu> = (props) => {
	const { isCollapsed } = props;
	const { label } = useSelector((state: IGeneralState) => state.app.user);
	const navigate = useNavigate();
	const isManager = label === "manager";
	return (
		<Sider
			className="sidemenu"
			style={{ display: isCollapsed ? "none" : "initial" }}
		>
			<div className="sidemenu__logo">
				<img
					src={logo}
					alt="logo"
					onClick={() => navigate("/dash")}
					style={{ cursor: "pointer" }}
				/>
			</div>
			<div className="sidemenu__content">
				{!isManager && (
					<>
						<div className="sidemenu__content__menu">
							<label>Início</label>
							<div className="sidemenu__content__menu__item">
								<Link to="/dash">Início</Link>
							</div>
							<div className="sidemenu__content__menu__item">
								<Link to="/my-courses">Meus cursos</Link>
							</div>
						</div>
						<hr />
					</>
				)}

				{!isManager && (
					<div className="sidemenu__content__menu">
						<label>Plataforma</label>
						<div className="sidemenu__content__menu__item">
							<Link to="/courses">Cursos</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/news">Notícias</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/faq">Central de ajuda</Link>
						</div>
					</div>
				)}

				{isManager && (
					<div className="sidemenu__content__menu">
						<label>Gerencial</label>
						<div className="sidemenu__content__menu__item">
							<Link to="/dash">Início</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-users">Usuários</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-courses">Cursos</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-news">Notícias</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-banners">Banners</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-products">Produto</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-newsletter">Newsletter</Link>
						</div>
					</div>
				)}
			</div>
		</Sider>
	);
};
